module.exports = __webpack_public_path__ + "img/jboard_icon-29.1caa3922.png";